/* LicensedTime home page: hero finder and "Shop now" chips, featured / My team tile, league-modular team section. */
(() => {
  'use strict';
  if (window.__ltHomeLoaded) return;
  window.__ltHomeLoaded = true;

  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const hex = (h) => (typeof h === 'string' && /^#[0-9a-f]{3,8}$/i.test(h) ? h : '');

  // "Browse all teams" / "All teams": open the Shop by Team menu (desktop) or the menu drawer (below 1024px)
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-lt-browse]')) return;
    if (window.matchMedia('(min-width: 1024px)').matches) {
      const toggle = $('[data-lt-mega-toggle]');
      const mega = $('[data-lt-mega]');
      if (toggle && mega && mega.hidden) toggle.click();
      const input = mega && $('.lt-finder__input', mega);
      if (input) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const pw = $('.page-wrapper');
        if (pw) pw.scrollTo({ top: 0, behavior: 'smooth' });
        input.focus({ preventScroll: true });
      }
    } else {
      const open = $('[data-lt-drawer-open]');
      if (open) open.click();
    }
  });

  const start = (LT) => {
    const live = LT.teams.filter((t) => t.live && t.u);

    /* ---------- hero: finder and chips ---------- */
    const hero = $('.lt-homehero');
    if (hero) {
      const label = $('[data-lt-finder]', hero);
      if (label) LT.initFinder(label, () => {});
    }

    /* ---------- featured team, replaced by My team when set ---------- */
    const feat = $('[data-lt-feature]');
    if (feat) {
      const original = feat.innerHTML;
      const wasHidden = feat.hidden;
      const tile = (t) => {
        const bg = hex(t.p) || '#16181b';
        const fg = hex(t.op) || '#ffffff';
        const fan = t.fn ? t.fn : `${t.s} fans`;
        return `<a class="lt-feat" href="${esc(t.u)}" style="--feat-bg:${bg};--feat-fg:${fg}"><span class="lt-feat__media">${t.img ? `<img class="lt-feat__img" src="${esc(t.img)}" alt="" loading="lazy">` : ''}</span><span class="lt-feat__copy"><span class="lt-feat__label">Your team</span><span class="lt-feat__headline">Welcome back, ${esc(fan)}</span><span class="lt-feat__text">${esc(t.n)} watches, clocks and tech, all in one place.</span><span class="lt-feat__cta">Shop ${esc(t.s)}</span></span></a>`;
      };
      const drawFeat = () => {
        const my = LT.getMyTeam();
        if (my && my.live && my.u) {
          feat.innerHTML = tile(my);
          feat.hidden = false;
        } else {
          feat.innerHTML = original;
          feat.hidden = wasHidden;
        }
      };
      drawFeat();
      document.addEventListener('lt:myteam', drawFeat);
    }

    /* ---------- team section ---------- */
    const sec = $('[data-lt-home-teams]');
    if (sec) {
      const leagueTabs = $('[data-lt-league-tabs]', sec);
      const groupTabs = $('[data-lt-group-tabs]', sec);
      const grid = $('[data-lt-team-tiles]', sec);
      const heading = $('[data-lt-teams-heading]', sec);
      const LABELS = { American: 'American & Ind.', Independent: 'American & Ind.' };
      const liveLeagues = LT.leagues.filter((l) => LT.teams.some((t) => t.lg === l.code && t.live));
      const shown = liveLeagues.length ? liveLeagues : LT.leagues;
      if (!shown.length) return;
      sec.hidden = false;
      let league = (LT.getMyTeam() && shown.find((l) => l.code === LT.getMyTeam().lg) && LT.getMyTeam().lg) || shown[0].code;
      let group = null;

      const draw = () => {
        const lg = shown.find((l) => l.code === league) || shown[0];
        const groups = LT.groupByConference(lg.code, LABELS);
        const grp = groups.find((g) => g.label === group) || groups[0];
        group = grp ? grp.label : null;
        heading.textContent = shown.length > 1 ? 'Shop by team' : `Shop by ${lg.code === 'NCAA' ? 'conference' : 'division'}`;
        leagueTabs.hidden = shown.length < 2;
        leagueTabs.innerHTML = shown
          .map((l) => `<button type="button" class="lt-leaguetab" role="tab" aria-selected="${l.code === lg.code}" data-league="${esc(l.code)}">${esc(l.name)}</button>`)
          .join('');
        groupTabs.setAttribute('aria-label', lg.code === 'NCAA' ? 'Conferences' : 'Divisions');
        groupTabs.hidden = groups.length < 2;
        groupTabs.innerHTML = groups
          .map((g) => `<button type="button" class="lt-grouptab" role="tab" aria-selected="${g.label === group}" data-group="${esc(g.label)}">${esc(g.label)}</button>`)
          .join('');
        grid.innerHTML = (grp ? grp.teams : [])
          .map((t) => {
            const badge = `<span class="lt-teamtile__badge" aria-hidden="true">${esc(t.c)}</span>`;
            if (t.live && t.u) {
              return `<a class="lt-teamtile" href="${esc(t.u)}" style="--tile-bg:${hex(t.p) || '#16181b'};--tile-fg:${hex(t.op) || '#ffffff'}">${badge}<span><span class="lt-teamtile__name">${esc(t.s)}</span><span class="lt-teamtile__status">Shop now</span></span></a>`;
            }
            return `<span class="lt-teamtile is-soon">${badge}<span><span class="lt-teamtile__name">${esc(t.s)}</span><span class="lt-teamtile__status">Coming soon</span></span></span>`;
          })
          .join('');
      };
      sec.addEventListener('click', (e) => {
        const l = e.target.closest('[data-league]');
        if (l) {
          league = l.dataset.league;
          group = null;
          draw();
          return;
        }
        const g = e.target.closest('[data-group]');
        if (g) {
          group = g.dataset.group;
          draw();
        }
      });
      draw();
    }
  };

  const ready = () => (window.LT && window.LT.teams ? start(window.LT) : document.addEventListener('lt:ready', () => start(window.LT), { once: true }));
  ready();
})();
